// **********************************************************
// Cart View
// **********************************************************
const cartModule = document.querySelector('.cart-module');
const cartPopupContent = document.querySelector('.cart-popup');

// Axios remove item from cart
const axiosRemoveItemFromCart = async (itemKey, source) => {
  const formDataInput = new FormData();
  formDataInput.append('action', 'removeItemFromCart');
  formDataInput.append('item_key', itemKey);
  formDataInput.append('source', source);

  try {
    const response = await axios.post(localData.siteURL, formDataInput, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    updateCartOnChange(response.data.data.cart_content_html, source);
    updateCartNumber(response.data.data.cart_contents_count);
  } catch (err) {
    console.error(err);
  }
};

const handleDeleteClick = (ev) => {
  if (ev.target.matches('.cart-view__delete i')) {
    const parentElem = ev.target.closest('.cart-view__item');
    const itemKey = parentElem.querySelector('.cart-item-key').value;
    parentElem.remove();

    if (cartModule) {
      if (cartModule.querySelectorAll('.cart-view__item').length === 0) {
        cartModule.classList.add('cart-module--empty');
      }
    } else if (cartPopupContent.querySelectorAll('.cart-view__item').length === 0) {
      cartPopupContent.classList.add('cart-popup--empty');
    }

    const source = cartModule ? 'cartPage' : 'popup';

    axiosRemoveItemFromCart(itemKey, source);
  }
};

if (cartModule) {
  cartModule.addEventListener('click', handleDeleteClick);
}

if (cartPopupContent) {
  cartPopupContent.addEventListener('click', handleDeleteClick);
}
